"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const LabelsCards_1 = __importDefault(require("../../molecules/LabelsCards"));
const LabelsLines_1 = __importDefault(require("../../molecules/LabelsLines"));
const providers_1 = require("../../providers");
const react_1 = require("react");
const hooks_1 = require("../../hooks");
const useSelectedLabel_1 = require("../../hooks/useSelectedLabel");
/* eslint-disable max-lines-per-function */
function LabelsPanel({ className, selectedToolType, isAddingLabels, trigger, }) {
    var _a;
    const { labels, currentModelPosition } = (0, hooks_1.useLabels)();
    const selectedLabel = (0, useSelectedLabel_1.useSelectedLabel)();
    const [expandedLabelID, setExpandedLabelID] = (0, react_1.useState)(null);
    const [updatePosition, setUpdatePosition] = (0, react_1.useState)(false);
    const [showLabelLines, setShowLabelLines] = (0, react_1.useState)(true);
    const [offsetChanged, setOffsetChanged] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (selectedLabel) {
            setShowLabelLines(true);
        }
    }, [selectedLabel]);
    if ((labels === null || labels === void 0 ? void 0 : labels.length) === 0) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(providers_1.LabelsProvider, { "data-e2e": 'LabelsPanel_LabelsProvider', children: (0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'LabelsPanel_Container', children: [(0, jsx_runtime_1.jsx)(LabelsLines_1.default, { currentModelPosition: currentModelPosition, expandedLabelID: expandedLabelID || '', updatePosition: updatePosition, showLabelLines: showLabelLines, offsetChanged: offsetChanged, "data-e2e": 'LabelsPanel_LabelsLines' }), (0, jsx_runtime_1.jsx)(LabelsCards_1.default, { labels: labels, selectedToolType: selectedToolType, currentStateIndex: (_a = selectedLabel === null || selectedLabel === void 0 ? void 0 : selectedLabel.modelPosition) !== null && _a !== void 0 ? _a : '', expandedLabelID: expandedLabelID || '', setExpandedLabelID: setExpandedLabelID, setUpdatePosition: setUpdatePosition, isAddingLabels: isAddingLabels, setShowLabelLines: setShowLabelLines, trigger: trigger, setOffsetChanged: setOffsetChanged, "data-e2e": 'LabelsPanel_LabelsCards' })] }) }));
}
exports.default = LabelsPanel;
const Container = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 0;

  width: 100vw;
  height: 100vh;
`;
